module.exports = __webpack_public_path__ + "assets/img/Infographics3.dbf5e639.png";